const useFontSizeCalculator = (fontSize: number, baseFontSize: number, unit: string) => {
  const fontScale = Number(fontSize) || 1;
  const computedFontSize = baseFontSize * fontScale;
  return `${computedFontSize}${unit}`;
};

export default useFontSizeCalculator;
